import { useEffect, useState } from 'react'
import CicloEntregaAcoesHttp from '../../../../../services/api/https/deliveries/ciclo-entrega-acoes.http'
import { gerarArquivoExcel } from '../../../../../services/util/excel.service'
import { errorHandler } from '../../../../../services/util/error.service'
import { getUsuarioInfo } from '../../../../../services/localstorage/localstorage.service'

export const BAIXAR_CANHOTOS_ACTIONS = {
  LOADING_DELIVERIES: 'LOADING_DELIVERIES',
  DOWNLOADING_CANHOTOS: 'DOWNLOADING_CANHOTOS',
  NONE: 'NONE',
}

const INITIAL_STATE = {
  deliveries: [],
  deliveriesFiltered: [],
  exibirEntregas: { name: 'Todas', value: 'ALL' },
  errorMessage: null,
  successMessage: null,
  loading: BAIXAR_CANHOTOS_ACTIONS.LOADING_DELIVERIES,
  totalDeliveries: 0,
  totalComCanhoto: 0,
  totalSemCanhoto: 0,
}

export default function useBaixarCanhotos(ciclo) {
  const [state, setState] = useState(INITIAL_STATE)

  useEffect(() => {
    async function fetchDeliveries() {
      try {
        const deliveries = await CicloEntregaAcoesHttp.getEntregasByCicloId(ciclo.id)
        const totalComCanhoto = deliveries.filter(d => d.tem_canhoto).length
        const totalSemCanhoto = deliveries.filter(d => !d.tem_canhoto).length

        setState({
          ...state,
          deliveries,
          deliveriesFiltered: deliveries,
          loading: BAIXAR_CANHOTOS_ACTIONS.NONE,
          totalDeliveries: deliveries.length,
          totalComCanhoto,
          totalSemCanhoto,
        })
      } catch (error) {
        setState({
          ...state,
          loading: BAIXAR_CANHOTOS_ACTIONS.NONE,
          errorMessage: errorHandler(error),
        })
      }
    }
    ciclo.id && !Number.isNaN(ciclo.id) && fetchDeliveries()
  }, [ciclo.id])

  // Actions
  const actions = {
    onFilterChange(filter) {
      const deliveriesFiltered = state.deliveries.filter(delivery => {
        const searchStr = filter.toLowerCase()
        return (
          delivery.identifier.toLowerCase().includes(searchStr) ||
          delivery.client_fantasia.toLowerCase().includes(searchStr) ||
          delivery.city_name.toLowerCase().includes(searchStr) ||
          delivery.district.toLowerCase().includes(searchStr) ||
          delivery.status.toLowerCase().includes(searchStr)
        )
      })
      setState(prevState => ({ ...prevState, deliveriesFiltered }))
    },

    onCheckBoxClicked(item, value) {
      const deliveries = state.deliveries.map(d => {
        if (d.delivery_id === item.delivery_id) {
          d.selected = value
        }
        return d
      })
      setState(prevState => ({ ...prevState, deliveries }))
    },

    onExibirEntregasChange(option) {
      setState(prev => ({
        ...prev,
        exibirEntregas: option,
        deliveriesFiltered: prev.deliveries.filter(d => {
          if (option.value === 'ALL') return true
          if (option.value === 'COM') return d.tem_canhoto
          if (option.value === 'SEM') return !d.tem_canhoto
          return true
        }),
      }))
    },

    onSelecionarTodos() {
      const deliveries = state.deliveries.map(item => {
        if (item.tem_canhoto) {
          item.selected = !state.selecionarTodos
        }
        return item
      })
      setState(prevState => ({
        ...prevState,
        deliveries,
        selecionarTodos: !state.selecionarTodos,
      }))
    },

    async onBaixarCanhotos() {
      try {
        setState(prevState => ({
          ...prevState,
          loading: BAIXAR_CANHOTOS_ACTIONS.DOWNLOADING_CANHOTOS,
        }))

        const selectedDeliveries = state.deliveries.filter(d => d.selected && d.tem_canhoto)
        if (!selectedDeliveries.length) {
          throw new Error('Nenhuma entrega com canhoto selecionada')
        }

        const deliveryIds = selectedDeliveries.map(d => d.delivery_id)
        const { id: user_id } = getUsuarioInfo()

        await CicloEntregaAcoesHttp.downloadCanhotos(deliveryIds, user_id)

        setState(prevState => ({
          ...prevState,
          loading: BAIXAR_CANHOTOS_ACTIONS.NONE,
          successMessage: 'Canhotos baixados com sucesso',
        }))
      } catch (error) {
        setState(prevState => ({
          ...prevState,
          loading: BAIXAR_CANHOTOS_ACTIONS.NONE,
          errorMessage: errorHandler(error),
        }))
      }
    },

    onExportarClick() {
      if (state.deliveriesFiltered.length !== 0) {
        const rows = [
          [
            'Identificador',
            'Cliente',
            'Qte SKUs',
            'Bairro',
            'Cidade',
            'Canhoto'
          ],
        ]

        state.deliveriesFiltered.forEach(p => {
          const {
            identifier,
            client_fantasia,
            qteSKU,
            district,
            city_name,
            tem_canhoto
          } = p
          rows.push([
            identifier,
            client_fantasia,
            qteSKU,
            district,
            city_name,
            tem_canhoto ? 'Sim' : 'Não'
          ])
        })
        gerarArquivoExcel('canhotos', rows, 'canhotos.xlsx')
      } else
        setState(prevState => ({
          ...prevState,
          errorMessage: 'Não existe canhoto para ser exportado.',
        }))
    },

    resetMessages() {
      setState(prevState => ({ ...prevState, errorMessage: null, successMessage: null }))
    },
  }

  return { state, actions }
}
